import React from 'react';

import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    info1Label: '通関書類とは？',
    info1Content: () => (
      <>
        日本の税関に輸入する商品の数量、単価、該当商品の材質、用途などの申告義務がありますので、輸入通関する時に、通関書類は必須です。
      </>
    ),
    info2Label: '通関書類',
    info2Content: () => (
      <>
        ①パッキングリスト（シッパー様よりご入手していただき、「書類アップロード」からアップロードしてください）
        <br />
        ②インボイス（シッパー様よりご入手していただき、「書類アップロード」からアップロードしてください）
        <br />
        ③該当商品の写真、絵型、もしくはURL（シッパー様よりご入手していただき、もしくは御社がお持ちであれば、「輸入商品一覧」に登録してから「商品説明」で選択してください。）
        <br />
        ④該当商品の材質、用途（御社より弊社に情報提供、「輸入商品一覧」に登録してから「商品説明」で選択してください。）
        <br />
        ⑤RCEPの利用には<b>原産地証明書</b>をご用意いただく必要があります。
        原産地証明書は輸出する物品の原産地を証明するための書類で、原則輸出者が用意します。
        原産地証明書は<b>本船出港後</b>
        に取得可能です。すみやかにお手続きを進めるため、書類入手後はお早目のアップロードにご協力お願いいたします。
        <br />
        <br />
        よろしければ、下記にてご参考をくださいませ
        <br />
        <a target="_blank" rel="noreferrer" href="https://hunade.com/yunyu-shorui-nagare">
          https://hunade.com/yunyu-shorui-nagare
        </a>
        <br />
      </>
    ),
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  customFilesInformationContainer: {
    ...common.textGray500,
    ...common.smallerText,
    padding: '1rem',
    background: '#FAFAFA',
    marginBottom: '1rem',
    '& a': {
      ...common.link,
    },
  },
}));

export const CustomFilesInformation: React.FC = () => {
  const classes = { ...useCommonStyles(), ...useStyles() };

  return (
    <div className={classes.customFilesInformationContainer}>
      <div className={classes.fontWeight600Important}>{strings.info1Label}</div>
      <div>{strings.info1Content()}</div>
      <div style={{ height: 30 }} />
      <div className={classes.fontWeight600Important}>{strings.info2Label}</div>
      <div>{strings.info2Content()}</div>
    </div>
  );
};
